module.exports = __webpack_public_path__ + "static/group-31-6c69a7c57bde501b8607f5460a80354f.png";